import { connect } from "react-redux";
import { ReloadOptions } from "@kontur.candy/candy-widget-npm-loader";

import {
    clearFormHandler,
    convertDraftFromPrevGfvAction,
    enableAutoValuesHandler,
    feedbackHandler,
    formSilentSaveAction,
    fufSaveHandler,
    innerSaveHandler,
    interdocumentTransferHandler,
    printHandler,
    restoreFormToSourceFuf,
    showTourHandler,
} from "../../../../Engine/ActionCreators/FormActionCreators";
import { setPopupPanel } from "../../../../Engine/ActionCreators/HiddenPanelActionCreators";
import { CandyDispatch } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { reloadAfterHistoryEditingAction } from "../../HistoryEditing/Store/HistoryEditingActionCreators";

import { ActionPanel } from "./ActionPanel";

const mapStateToProps = (state: FullFormState) => ({
    panelState: state.formVisualState.panelState,
    isPopupPanel: state.formVisualState.isPopupPanel ?? false,
    isFufDownloading: state.formVisualState.isFufDownloading ?? false,
    isInnerDownloading: state.formVisualState.isInnerDownloading ?? false,
    formSettings: state.settings,
    showDraftHistoryInEditor: state.featureFlags?.showDraftHistoryInEditor === "true",
});

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    setPopupPanel: (isPopupPanel: boolean, isFrozenPopup?: boolean) =>
        dispatch(setPopupPanel(isPopupPanel, isFrozenPopup)),
    onSaveForm: () => dispatch(formSilentSaveAction),
    onSaveFuf: () => dispatch(fufSaveHandler),
    onFormClear: () => dispatch(clearFormHandler),
    onRestoreToSourceFuf: () => dispatch(restoreFormToSourceFuf),
    onRunFeedback: () => dispatch(feedbackHandler),
    onSaveInner: () => dispatch(innerSaveHandler),
    onPrintFuf: () => dispatch(printHandler),
    onShowTour: () => {
        dispatch(showTourHandler);
    },
    onConvertDraftFromPrevGfv: () => dispatch(convertDraftFromPrevGfvAction),
    onRunExternalInterdocumentTransfer: () => {
        dispatch(interdocumentTransferHandler);
    },
    onEnableAutoValues: () => dispatch(enableAutoValuesHandler),
    reload: (options: ReloadOptions) => dispatch(reloadAfterHistoryEditingAction(options)),
});

export const ActionPanelContainer = connect(mapStateToProps, mapDispatchToProps)(ActionPanel);
